import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import SimpleAccordion from "src/qubCommon/Accordions/SimpleAccordion";
import { Groups, Sync, Visibility } from "@mui/icons-material";
import ChildrenTable from "./ChildrenTable";
import "./Children.css";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import ReviewSection from "qubCommon/ReviewSection";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import { validateChildren } from "apis/controllers/externalData";
import { useParams } from "react-router-dom";
import { createMarkup } from "util/createMarkup";
import { useFormContext } from "react-hook-form";

const Children = ({ children, settings, review }) => {
  const [loading, setLoading] = useState(false);
  const [checkInfo, setCheckInfo] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { id } = useParams();
  const form = useFormContext();

  const renderModalContent = () => {
    if (!checkInfo) return null;

    return <div dangerouslySetInnerHTML={createMarkup(checkInfo?.message)} />;
  };

  const handleCheck = async () => {
    setLoading(true);
    try {
      const result = await validateChildren(id);
      setCheckInfo(result?.data);
      setOpenModal(true);
    } catch (err) {
      console.error("Error during check:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (review?.wsResponse?.message)
      setCheckInfo({
        message: review?.wsResponse?.message,
        timestamp: review?.wsResponse?.timestamp,
        clipboardText: review?.wsResponse?.clipboardText,
      });
  }, [review]);

  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <Groups color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΣΤΟΙΧΕΙΑ ΕΠΙΛΕΞΙΜΩΝ ΤΕΚΝΩΝ
      </Typography>
      <Typography color="primary">
        ({form?.watch("childrenHelp")?.length})
      </Typography>
    </Stack>
  );

  return (
    <CustomSimpleAccordion
      title={<AccordionTitle />}
      content={
        <Grid container>
          <ChildrenTable
            children={children}
            canEdit={settings?.canEdit}
            canPartiallyEdit={settings?.canPartiallyEdit}
            canAdd={settings?.canAdd}
            canDelete={settings?.canDelete}
          />
          <Grid item xs={12}>
            <ReviewSection
              canApprove={settings?.canApprove}
              canViewReview={settings?.canViewReview}
              canViewWSResult={settings?.canViewWSResult}
              fieldPrefix="reviews.children"
              extra={
                <Grid item xs={12} style={{ display: "flex" }} gap={1}>
                  {settings?.canApprove && (
                    <Button
                      onClick={handleCheck}
                      variant="contained"
                      startIcon={
                        loading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <Sync />
                        )
                      }
                      disabled={loading}
                    >
                      WebService - Έλεγχος
                    </Button>
                  )}

                  {checkInfo &&
                    (settings?.canApprove || settings?.canViewWSResult) && (
                      <div style={{ marginLeft: "auto", display: "flex" }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          mt={1}
                          mr={1}
                        >
                          Τελευταίος Έλεγχος: {checkInfo.timestamp}
                        </Typography>
                        <Button
                          variant="outlined"
                          startIcon={<Visibility />}
                          onClick={() => setOpenModal(true)}
                        >
                          Αποτελέσματα Ελέγχου
                        </Button>
                      </div>
                    )}
                </Grid>
              }
            />
          </Grid>
          {/* Modal */}
          <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle>Αποτελέσματα Ελέγχου Τέκνων</DialogTitle>
            <DialogContent>{renderModalContent()}</DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpenModal(false)}
              >
                Κλείσιμο
              </Button>
              {settings?.canApprove && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    form.setValue(
                      "reviews.children.comments",
                      checkInfo?.clipboardText
                    );
                    setOpenModal(false);
                  }}
                >
                  Ενημέρωση Παρατηρήσεων
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Grid>
      }
    />
  );
};

export default Children;
